import React from "react";
import { FiSearch } from "react-icons/fi";

const ACTION_OPTIONS = [
  { value: "", label: "Të gjitha veprimet" },
  { value: "PatientViewed", label: "Shikim i pacientit" },
  { value: "PatientCreated", label: "Krijim i pacientit" },
  { value: "PatientUpdated", label: "Përditësim i pacientit" },
  { value: "PatientDeleted", label: "Fshirje e pacientit" },
  { value: "PatientAnonymized", label: "Anonimizim i pacientit" },
  { value: "PatientExported", label: "Eksport i pacientit" },
  { value: "MedicalRecordViewed", label: "Shikim i kartelës" },
  { value: "MedicalRecordUpdated", label: "Përditësim i kartelës" },
  { value: "Login", label: "Hyrje" },
  { value: "Logout", label: "Dalje" },
];

const ENTITY_OPTIONS = [
  { value: "", label: "Të gjithë entitetet" },
  { value: "Patient", label: "Pacient" },
  { value: "MedicalRecord", label: "Kartelë mjekësore" },
  { value: "Appointment", label: "Takim" },
  { value: "Visit", label: "Vizitë" },
  { value: "File", label: "Skedar" },
  { value: "User", label: "Përdorues" },
];

export default function AuditLogFilters({
  draftFilters,
  onDraftChange,
  onApply,
  onClear,
  loading,
}) {
  return (
    <div className="card p-4 sm:p-5 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-3 items-end">
        <div className="xl:col-span-2">
          <label className="label">Kërko</label>
          <div className="input-icon-wrap">
            <FiSearch className="input-icon" size={18} />
            <input
              type="search"
              className="input-with-icon"
              value={draftFilters.search}
              onChange={(e) => onDraftChange("search", e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") onApply();
              }}
              placeholder="Emri i pacientit ose i përdoruesit…"
            />
          </div>
        </div>

        <div>
          <label className="label">Veprimi</label>
          <select
            className="input"
            value={draftFilters.action}
            onChange={(e) => onDraftChange("action", e.target.value)}
          >
            {ACTION_OPTIONS.map((item) => (
              <option key={item.value || "all-actions"} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="label">Entiteti</label>
          <select
            className="input"
            value={draftFilters.entityName}
            onChange={(e) => onDraftChange("entityName", e.target.value)}
          >
            {ENTITY_OPTIONS.map((item) => (
              <option key={item.value || "all-entities"} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="label">Nga data</label>
          <input
            type="date"
            className="input"
            value={draftFilters.fromDate}
            onChange={(e) => onDraftChange("fromDate", e.target.value)}
          />
        </div>

        <div>
          <label className="label">Deri më</label>
          <input
            type="date"
            className="input"
            value={draftFilters.toDate}
            onChange={(e) => onDraftChange("toDate", e.target.value)}
          />
        </div>
      </div>

      <div className="mt-4 flex items-center gap-2">
        <button type="button" className="btn-primary btn-sm" onClick={onApply} disabled={loading}>
          Apliko filtrat
        </button>
        <button type="button" className="btn-secondary btn-sm" onClick={onClear} disabled={loading}>
          Pastro filtrat
        </button>
      </div>
    </div>
  );
}
